import { Bell, CircleDollarSign, Clover, Gem, Spade, Trophy } from "lucide-react";

/* Slots cabinet presentation extracted from CasinoCefPage. */
export const SLOT_SYMBOLS = [
  { id: "seven", label: "7", color: "#f43f5e" },
  { id: "diamond", Icon: Gem, color: "#67e8f9" },
  { id: "bell", Icon: Bell, color: "#d4af37" },
  { id: "spade", Icon: Spade, color: "#e4e4e7" },
  { id: "chip", Icon: CircleDollarSign, color: "#34d399" },
  { id: "horseshoe", Icon: Clover, color: "#a78bfa" },
];
export const PAYTABLE = [["seven", 50], ["diamond", 25], ["bell", 15], ["spade", 10], ["chip", 8], ["horseshoe", 5]];
export const SYM_H = 84;
const GOLD = "#d4af37";
const fmt = (n) => `$${Number(n).toLocaleString()}`;

export function Sym({ id, size = 40 }) {
  const s = SLOT_SYMBOLS.find((x) => x.id === id);
  if (!s) return null;
  if (s.label) return <span className="font-black" style={{ fontSize: size, color: s.color, textShadow: `0 0 14px ${s.color}88` }}>{s.label}</span>;
  return <s.Icon style={{ width: size, height: size, color: s.color, filter: `drop-shadow(0 0 8px ${s.color}66)` }} />;
}

export default function SlotsCabinet({ jackpotFlash, reels, reelPos, reelSpinning, slotWin, slotBusy, payoutCount,
                                       bank, slotBet, setSlotBet, leverPulled, setLeverPulled, spinSlots, roomChips, later }) {
  return (
    <>
      <div data-testid="slots-cabinet" className="relative w-full max-w-[540px] rounded-2xl px-6 pb-5 pt-2"
        style={{
          background: "linear-gradient(165deg, #3a2c12 0%, #241a0a 45%, #120b04 100%)",
          border: `2px solid ${GOLD}77`,
          boxShadow: "0 0 60px #000000cc, inset 0 2px 0 #d4af3755",
          animation: jackpotFlash ? "ncCabinetStrobe 0.55s ease-in-out infinite" : "none",
        }}>
        <div className="relative -mx-6 rounded-t-2xl overflow-hidden py-3 mb-5 border-b border-[#d4af3744]" style={{ background: "linear-gradient(180deg, #171006, #0b0703)" }}>
          <div className="absolute inset-x-4 top-1 flex justify-between" aria-hidden>
            {Array.from({ length: 12 }, (_, i) => <span key={i} className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: GOLD, animation: `ncBulb 1.6s ease-in-out ${i * 0.13}s infinite` }} />)}
          </div>
          <div className="absolute inset-x-4 bottom-1 flex justify-between" aria-hidden>
            {Array.from({ length: 12 }, (_, i) => <span key={i} className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: GOLD, animation: `ncBulb 1.6s ease-in-out ${(i + 6) * 0.13}s infinite` }} />)}
          </div>
          <p className="relative text-center font-black uppercase tracking-[0.35em] text-base" style={{ color: GOLD, textShadow: `0 0 18px ${GOLD}aa` }}>The Gilded Spade</p>
          <p className="relative text-center font-mono text-[8px] uppercase tracking-[0.45em] text-zinc-500 mt-0.5">Liberty Belle · three reel</p>
        </div>

        <div className="relative">
          <div className="relative flex gap-3 p-4 rounded-lg" style={{ backgroundColor: "#050505", boxShadow: "inset 0 0 30px #000" }}>
            {reels.map((sym, i) => (
              <div key={i} data-testid={`reel-${i}`} className="relative flex-1 overflow-hidden rounded border border-[#d4af3733]" style={{ height: SYM_H }}>
                <div className="absolute left-0 w-full flex flex-col items-center"
                  style={{ transform: `translateY(${-reelPos[i] * SYM_H}px)`, transition: reelSpinning[i] ? `transform ${1.5 + i * 0.55}s cubic-bezier(0.25, 0.7, 0.2, 1)` : "none", filter: reelSpinning[i] ? "blur(2.5px)" : "none" }}>
                  {Array.from({ length: 60 }, (_, j) => SLOT_SYMBOLS[j % SLOT_SYMBOLS.length].id).map((id, j) => (
                    <div key={j} className="flex items-center justify-center" style={{ height: SYM_H }}><Sym id={id} size={38} /></div>
                  ))}
                </div>
                <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(#00000088, transparent 30%, transparent 70%, #00000088)" }} />
              </div>
            ))}
            <div className="absolute inset-0 rounded-lg pointer-events-none" style={{ background: "linear-gradient(115deg, #ffffff14 0%, transparent 28%, transparent 72%, #ffffff08 100%)" }} />
          </div>
          <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 pointer-events-none flex items-center" aria-hidden>
            <span style={{ borderTop: "8px solid transparent", borderBottom: "8px solid transparent", borderLeft: `10px solid ${GOLD}` }} />
            <span className="flex-1 border-t" style={{ borderColor: `${GOLD}55`, boxShadow: `0 0 8px ${GOLD}66`, animation: slotWin && !slotBusy ? "ncPaylinePulse 0.7s ease-in-out infinite" : "none" }} />
            <span style={{ borderTop: "8px solid transparent", borderBottom: "8px solid transparent", borderRight: `10px solid ${GOLD}` }} />
          </div>
          {slotWin && !slotBusy && (
            <div data-testid="slot-result" className="absolute inset-x-4 top-1/2 -translate-y-1/2 text-center py-4 border backdrop-blur-sm z-10"
              style={{ backgroundColor: "#000000dd", borderColor: `${GOLD}88`, animation: "ncFadeUp 0.3s ease both" }}>
              <Trophy className="w-6 h-6 mx-auto mb-1" style={{ color: GOLD }} />
              <p className="font-black text-2xl tracking-[0.1em]" style={{ color: GOLD, textShadow: `0 0 20px ${GOLD}aa` }}>{slotWin.win_kind === "jackpot" ? "JACKPOT" : "WINNER"}</p>
              <p data-testid="slot-payout-count" className="font-mono text-lg font-bold text-emerald-400">+{fmt(payoutCount)}</p>
            </div>
          )}
        </div>

        <button data-testid="slots-lever" disabled={slotBusy || slotBet > (bank ?? 0)}
          onClick={() => { setLeverPulled(true); spinSlots(); later(() => setLeverPulled(false), 600); }}
          className="absolute -right-2 top-28 flex flex-col items-center gap-1 disabled:opacity-40 group" aria-label="Pull the lever">
          <span className="w-2.5 rounded-full transition-all duration-300" style={{ height: leverPulled ? 46 : 72, background: "linear-gradient(180deg,#6b7280,#374151)", boxShadow: "inset 0 0 4px #000" }} />
          <span className={`w-7 h-7 rounded-full border-2 transition-transform duration-300 ${leverPulled ? "-translate-y-11" : ""}`} style={{ background: "radial-gradient(circle at 35% 30%, #ff8a3c, #b45309)", borderColor: "#7c2d12", boxShadow: "0 0 16px #ff6b1a88" }} />
          <span className="font-mono text-[7px] uppercase tracking-[0.2em] text-zinc-500 group-hover:text-zinc-300 transition-colors">Pull</span>
        </button>

        <div className="flex items-center gap-3 mt-5">
          <div className="flex gap-1.5">
            {roomChips.map((c) => (
              <button key={c} data-testid={`slots-bet-${c}`} onClick={() => setSlotBet(c)}
                className={`px-3 py-2 font-mono text-[10px] border transition-colors ${slotBet === c ? "text-black" : "text-zinc-400 border-white/15"}`}
                style={slotBet === c ? { backgroundColor: GOLD, borderColor: GOLD } : {}}>{c}</button>
            ))}
          </div>
          <button data-testid="slots-spin" disabled={slotBusy || slotBet > (bank ?? 0)} onClick={spinSlots}
            className="flex-1 py-3 font-mono text-xs uppercase tracking-[0.35em] font-bold text-black disabled:opacity-40"
            style={{ backgroundColor: GOLD, boxShadow: `0 0 24px ${GOLD}44` }}>
            {slotBusy ? "Rolling…" : `Spin ${fmt(slotBet)}`}
          </button>
        </div>

        <div className="mt-4 mx-2 rounded-b-xl border-t border-[#d4af3722] pt-2 pb-1 relative overflow-hidden" style={{ background: "linear-gradient(180deg,#0c0804,#050301)", minHeight: 30 }}>
          {jackpotFlash && Array.from({ length: 14 }, (_, i) => (
            <span key={i} className="absolute w-2 h-2 rounded-full" aria-hidden
              style={{ left: `${6 + i * 6.5}%`, top: 0, background: "radial-gradient(circle at 35% 30%, #ffe08a, #b8860b)", animation: `ncCoinFall ${0.8 + (i % 5) * 0.13}s ease-in ${i * 0.07}s infinite` }} />
          ))}
          <p className="text-center font-mono text-[8px] uppercase tracking-[0.4em] text-zinc-600">{jackpotFlash ? "Jackpot — payout raining" : "Coin tray"}</p>
        </div>
      </div>

      <div className="border border-white/10 bg-black/50 p-5 w-full max-w-[540px]">
        <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-zinc-500 mb-3">Paytable · three of a kind</p>
        <div className="grid grid-cols-2 gap-x-6">
          {PAYTABLE.map(([id, mult]) => (
            <div key={id} className="flex items-center gap-3 py-1.5 border-b border-white/5">
              <Sym id={id} size={22} />
              <span className="font-mono text-[10px] uppercase text-zinc-400">{id}</span>
              <span className="ml-auto font-mono text-xs font-bold" style={{ color: GOLD }}>{mult}x</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
